
<template>
    <ListDetailLayout
		    :store="deviceTypesStore"
        index-route-name="admin.devices.types"
		    create-permissions="create:device-types"
		    @on-create="$router.push({ name: 'admin.devices.types.type', params: { type: 'NEW' } })"
		    @on-paginate="(page) => useOnPaginate(page, refreshDeviceTypes, params)"
		    @on-search="(page) => useOnSearch(page, refreshDeviceTypes, params)"
			create-button-admin-page="create-device-type-admin-btn"
	        search-admin-page="search-device-type-admin-page"
    >

        <template #list>
            <li v-for="type in deviceTypesStore.getDeviceTypes" :key="type.id">
                <router-link :to="{ name: 'admin.devices.types.type', params: { type: type.id } }" v-slot="{isActive}">
                    <div :class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">

                        <div class="min-w-0">
                            <div class="flex items-start gap-x-3">
                                <p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">{{ type.name }}</p>
                            </div>

		                        <div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400">
				                        <p class="whitespace-nowrap">
					                          {{ typeCompanyLabel(type) }}
				                        </p>
		                        </div>
                        </div>

                    </div>
                </router-link>
            </li>
        </template>

        <template #detail>
            <router-view v-if="$route.params.type" @on-save="refreshDeviceTypes" @on-delete="refreshDeviceTypes"></router-view>
        </template>

    </ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import { mapStores } from "pinia";
import { useDeviceTypesStore } from "@/stores/deviceTypes.js";
import { useOnPaginate, useOnSearch } from "@/Composables/Pagination.js";

export default {
	name: "DeviceTypesIndex",
	data() {
		return {
			params: {
				include: ['company', 'companies'],
			}
		}
	},
	methods: {
		useOnSearch,
		useOnPaginate,
		refreshDeviceTypes(){
			return this.deviceTypesStore.indexDeviceTypes(this.params);
		},
    typeCompanyLabel(type) {
      if (type.companies?.length) {
        return type.companies.map(company => company.name).join(', ');
      }

      return type.company?.name ?? this.$t('common.public');
    },
	},
	components: {Container, ListDetailLayout},
	computed: {
		...mapStores(useDeviceTypesStore)
	},
	async mounted() {
		await this.refreshDeviceTypes();
	}
}
</script>
